/**
 * Canonical WhatsApp contact for Pierre — single source of truth.
 *
 * The number was previously hardcoded in two landing components in two
 * different URL formats (`wa.me` and `api.whatsapp.com/send`), and was absent
 * from the mobile app and the capabilities skill — so users had no way to
 * discover which number to message (PIERRE feedback: "Pierre doesn't know the
 * personal WhatsApp number"). Centralising it here lets the landing pages, the
 * mobile app, and the skill all reference one value.
 */

/** Pierre's WhatsApp number in E.164 without the `+` (wa.me / api.whatsapp.com format). */
export const PIERRE_WHATSAPP_NUMBER = '5511953250832';

/** Human-readable Brazilian formatting, e.g. +55 (11) 95325-0832. */
export const PIERRE_WHATSAPP_NUMBER_DISPLAY = '+55 (11) 95325-0832';

const DEFAULT_WHATSAPP_MESSAGE = 'Olá! Gostaria de saber mais sobre o Pierre.';

/**
 * Builds a `wa.me` deep link to open a chat with Pierre on WhatsApp.
 *
 * `wa.me` is preferred over `api.whatsapp.com/send` for cross-platform deep
 * linking: it works on mobile (opens the WhatsApp app) and desktop (opens
 * WhatsApp Web) without extra query params.
 *
 * @param message - Optional prefilled message (URL-encoded). Defaults to a
 *                  generic greeting so the link is never empty.
 */
export function buildPierreWhatsAppUrl(
  message: string = DEFAULT_WHATSAPP_MESSAGE,
): string {
  return `https://wa.me/${PIERRE_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
